import React, { useState, useEffect } from "react";
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Box, Card, CardHeader, Stack, Typography } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------



function AppPracticePrescriptions2(props) {
  const [data, setData] = useState([0,0,0,0,0]);
  useEffect(() => {
    if (props.patients_visits && props.patients_visits.categories) {
      let temp = props.patients_visits.categories.map(cat => cat.count)
      setData(temp);
    }else {
      setData([0,0,0,0,0])
    }
  }, [props.patients_visits]);

  const chartOptions = merge(BaseOptionChart(), {
    colors: ['#3E839733', '#3E839766', '#3E839799', '#3E8397CC', '#3E8397'],
    labels: ['None', 'Once', '2-3 times', 'Monthly', 'Multiple times per month'],
    legend: { 
      show: false  // Hide the legend
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(0) + "%"
      },
      style: {
        fontSize: '15px',
        fontWeight: 'bold',
        colors: ['#fff']
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '14px',
              color: '#22577A'
            },
            value: {
              show: true,
              fontSize: '14px',
              color: '#3E8397',
              formatter: function (val) {
                return val.toFixed(0) + '%'
              }
            },
            total: {
              show: false
            }
          },
          size: '50%'
        },
        expandOnClick: false
      }
    },
    tooltip: {
      y: {
        formatter: (value) => fNumber(value) 
      }
    }
  });

  return (
    <Card sx={{ boxShadow: 'none', mt: 4, height: 400 }} >
      <Box sx={{ mt: 4, mx: 5, width: 450, height: 350 }} dir="ltr">
        <ReactApexChart
          type="donut"
          series={data}
          options={chartOptions}
          height={350}
        />
      </Box>
    </Card>
  );
}


import { connect } from "react-redux";
const mapState = state => ({
  patients_visits: state.overview.patients_visits
});

const mapDispatch = ({
  overview: { loadData } }) => ({
    loadData: () => loadData()
  });

export default connect(mapState, mapDispatch)(AppPracticePrescriptions2);

